import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { Play, ArrowRight } from 'lucide-react';

export const DemoModal = ({ open, onOpenChange, onContactSales }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-4xl bg-neutral-900 border-amber-500/20 p-0 overflow-hidden [&>button]:text-white [&>button]:hover:text-amber-400 [&>button]:opacity-100">
      <DialogHeader className="p-6 pb-0">
        <DialogTitle className="flex items-center gap-3 text-xl text-white">
          <div className="w-10 h-10 rounded-lg bg-amber-500/20 flex items-center justify-center">
            <Play className="w-5 h-5 text-amber-400" />
          </div>
          SlotFleet Platform Demo
        </DialogTitle>
      </DialogHeader>
      <div className="p-6">
        <div className="relative aspect-video bg-black rounded-xl overflow-hidden border border-amber-500/10">
          <video
            className="w-full h-full object-cover"
            controls
            autoPlay
            loop
            playsInline
            poster="/demo-poster.jpg"
            data-testid="demo-video-player"
          >
            <source src="/demo-video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { icon: '\ud83d\udcca', label: 'Real-time Dashboard' },
            { icon: '\ud83d\udce6', label: 'Inventory Tracking' },
            { icon: '\ud83d\uddfa\ufe0f', label: 'Route Planning' },
            { icon: '\ud83d\udcb0', label: 'Automated Invoicing' },
          ].map((feature, idx) => (
            <div key={idx} className="flex items-center gap-2 text-sm text-gray-400 bg-white/5 rounded-lg px-3 py-2">
              <span>{feature.icon}</span>
              <span>{feature.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/signup" className="w-full sm:w-auto">
            <Button className="w-full bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-400 hover:to-yellow-400 text-black font-bold px-8">
              Start Free Trial
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <Button
            variant="link"
            className="text-amber-400 hover:text-amber-300"
            onClick={() => {
              onOpenChange(false);
              onContactSales(true);
            }}
          >
            Request personalized demo
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
